import { Link } from 'react-router'

import { Icon } from '@/components/Icon'

export interface Crumb {
  label: string
  to?: string
}

/** Where you are, and one click back to everything above it. */
export function Breadcrumb({ trail }: { trail: Crumb[] }) {
  return (
    <nav className="text-ink-500 mb-1 flex flex-wrap items-center gap-1 text-[11px]">
      {trail.map((crumb, index) => (
        <span key={`${crumb.label}-${index}`} className="flex items-center gap-1">
          {index > 0 ? <Icon name="chevron" className="size-3 opacity-50 rtl:-scale-x-100" /> : null}
          {crumb.to === undefined ? (
            <span className="text-ink-700">{crumb.label}</span>
          ) : (
            <Link to={crumb.to} className="hover:text-ink-900 hover:underline">
              {crumb.label}
            </Link>
          )}
        </span>
      ))}
    </nav>
  )
}
